import React from "react";
import LegalShell from "./components/LegalShell";
import { useLang } from "./LangContext";

// All [PLATZHALTER] markers must be replaced or verified before going live.
export default function TermsPage() {
  const { t } = useLang();
  return (
    <LegalShell>
      <h1>{t.termsTitle}</h1>

      <h2>1. Geltungsbereich</h2>
      <p>
        Diese AGB gelten für die Nutzung der Buchungsplattform SessionHoster, betrieben von{" "}
        <span className="legal-placeholder">[Vorname Nachname, Adresse]</span>{" "}
        (nachfolgend „Anbieter").
      </p>

      <h2>2. Leistungsbeschreibung</h2>
      <p>
        SessionHoster stellt eine webbasierte Terminbuchungsplattform bereit. Kunden können
        über die Plattform Terminanfragen an registrierte Dienstleister stellen. Ein Termin
        gilt erst als verbindlich bestätigt, wenn der Dienstleister die Buchung ausdrücklich
        angenommen hat.
      </p>

      <h2>3. Buchungsvorgang</h2>
      <p>
        Eine Buchungsanfrage durch den Kunden stellt noch keine verbindliche Buchung dar. Der
        Dienstleister kann die Anfrage annehmen oder ablehnen. Kunden erhalten in beiden Fällen
        eine E-Mail-Benachrichtigung.
      </p>

      <h2>4. Stornierung</h2>
      <p>
        Kunden können eine bestätigte Buchung über den in der Bestätigungs-E-Mail enthaltenen
        Stornierungslink absagen. Stornierungsfristen und etwaige Ausfallgebühren richten sich
        nach den individuellen Bedingungen des jeweiligen Dienstleisters.
      </p>

      <h2>5. Haftung</h2>
      <p>
        Die Plattform vermittelt lediglich die technische Infrastruktur zur Terminvereinbarung.
        Der Anbieter übernimmt keine Haftung für die Qualität der durch Dienstleister erbrachten
        Leistungen. Die Haftung für leichte Fahrlässigkeit ist, soweit gesetzlich zulässig,
        ausgeschlossen.
      </p>

      <h2>6. Änderungen der AGB</h2>
      <p>
        Der Anbieter behält sich das Recht vor, diese AGB jederzeit zu ändern. Änderungen
        werden durch Veröffentlichung auf dieser Seite bekannt gegeben. Die fortgesetzte
        Nutzung der Plattform gilt als Zustimmung zu den geänderten Bedingungen.
      </p>

      <h2>7. Anwendbares Recht und Gerichtsstand</h2>
      <p>
        Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist{" "}
        <span className="legal-placeholder">[Ort des Anbieters]</span>, sofern der Kunde
        Kaufmann, juristische Person des öffentlichen Rechts oder öffentlich-rechtliches
        Sondervermögen ist.
      </p>
    </LegalShell>
  );
}
